import { render, staticRenderFns } from "./dialog-outboxdetail.vue?vue&type=template&id=65d08247&"
import script from "./dialog-outboxdetail.vue?vue&type=script&lang=js&"
export * from "./dialog-outboxdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports